/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffDocument } from './StaffDocument';
import {
    StaffDocumentFromJSON,
    StaffDocumentFromJSONTyped,
    StaffDocumentToJSON,
    StaffDocumentToJSONTyped,
} from './StaffDocument';

/**
 * 
 * @export
 * @interface StaffDocumentPage
 */
export interface StaffDocumentPage {
    /**
     * 
     */
    documents: Array<StaffDocument>;
    /**
     * 
     */
    next_cursor: string | null;
}

/**
 * Check if a given object implements the StaffDocumentPage interface.
 */
export function instanceOfStaffDocumentPage(value: object): value is StaffDocumentPage {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    if (!('next_cursor' in value) || value['next_cursor'] === undefined) return false;
    return true;
}

export function StaffDocumentPageFromJSON(json: any): StaffDocumentPage {
    return StaffDocumentPageFromJSONTyped(json, false);
}

export function StaffDocumentPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffDocumentPage {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(StaffDocumentFromJSON)),
        'next_cursor': json['next_cursor'],
    };
}

export function StaffDocumentPageToJSON(json: any): StaffDocumentPage {
    return StaffDocumentPageToJSONTyped(json, false);
}

export function StaffDocumentPageToJSONTyped(value?: StaffDocumentPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': ((value['documents'] as Array<any>).map(StaffDocumentToJSON)),
        'next_cursor': value['next_cursor'],
    };
}

